import { useDispatch, useSelector } from "react-redux";
import { loaderSelector, loaderActions } from "../store/loader-slice";

const useLoading = () => {
  const dispatch = useDispatch();

  const { showLoader } = useSelector(loaderSelector);

  const setShowLoader = (showLoading) => {
    dispatch(loaderActions.showLoader(showLoading));
  };

  return {
    showLoader,
    setShowLoader,
  };
};

export default useLoading;
